"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skill = void 0;
const useStore_entities_1 = require("../../contexts/useStore/useStore.entities");
class Skill extends useStore_entities_1.Entity {
    static cache = true;
    static all = () => ({
        api: 'v1',
        method: 'GET',
        route: '/skills',
        wrapper: 'data',
    });
    static affinities = ({ id }) => ({
        api: 'v1',
        method: 'GET',
        route: `/skills/${id}/skills_affinities`,
    });
    static sort = (a, b) => a.attributes['name'].localeCompare(b.attributes['name']);
}
exports.Skill = Skill;
//# sourceMappingURL=Skill.js.map